export enum ResourceTypeDistribution {
  EqualBucketSize = 0,
  DynamicBucketSize = 1
}
